import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { CsIconModule } from '@components/icon';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'app-isotretinoin-consent-pending',
  templateUrl: './isotretinoin-consent-pending.component.html',
  imports: [CsIconModule],
})
export class IsotretinoinConsentPendingComponent {
  private readonly router = inject(Router);
  private readonly eventLogger = inject(EventLoggerService);

  orderId = input.required<string>();
  pregnancyAnswered = input<boolean>(false);

  onClick(): void {
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'isotretinoin_consent_pending_banner' }));
    this.router.navigate(['/safety-check-question'], {
      queryParams: {
        orderId: this.orderId(),
        ...(this.pregnancyAnswered() && { view: 'consent' }),
      },
    });
  }
}
